// คำนวณยอดประมาณการสหกรณ์ออมทรัพย์จากรายการยืนยันยอดล่าสุด
// หลักคิด: สหกรณ์หักซื้อหุ้นพร้อมเงินเดือน "สิ้นเดือน" — จึงนับเฉพาะเดือนที่สิ้นเดือนผ่านไปแล้ว
// หลังวันที่ในหนังสือยืนยันยอด (ถ้าหนังสือลงวันที่ 31 ธ.ค. → เริ่มนับ ม.ค.; ถ้าลง 15 ม.ค. → นับ ม.ค. ด้วยเมื่อถึงสิ้น ม.ค.)

export function toDateOnly(v) {
    if (!v) return null;
    const s = String(v).slice(0, 10); // รองรับทั้ง 'YYYY-MM-DD' และ ISO datetime
    const [y, m, d] = s.split('-').map(Number);
    if (!y || !m || !d) return null;
    return new Date(y, m - 1, d);
}

// จำนวน "สิ้นเดือน" ที่อยู่ในช่วง (confirmed, today]
export function monthsElapsed(confirmedDate, today = new Date()) {
    const c = toDateOnly(confirmedDate);
    if (!c) return 0;
    const t = new Date(today.getFullYear(), today.getMonth(), today.getDate());
    let count = 0;
    // สิ้นเดือนแรกที่อาจนับได้ = สิ้นเดือนของเดือนที่ออกหนังสือ
    let y = c.getFullYear();
    let m = c.getMonth();
    for (let i = 0; i < 1200; i++) {
        const monthEnd = new Date(y, m + 1, 0);
        if (monthEnd > t) break;
        if (monthEnd > c) count++;
        m++;
        if (m > 11) { m = 0; y++; }
    }
    return count;
}

// เดือนที่คาดว่าจะหักงวดสุดท้าย (สิ้นเดือน) เมื่อยังเหลืออีก n งวด
// ถ้าวันนี้เป็นวันสิ้นเดือน ถือว่างวดของเดือนนี้หักไปแล้ว (นับตรงกับ monthsElapsed) → งวดถัดไปคือเดือนหน้า
export function payoffMonth(n, today = new Date()) {
    if (!n || n <= 0) return null;
    const lastDay = new Date(today.getFullYear(), today.getMonth() + 1, 0).getDate();
    const startOffset = today.getDate() >= lastDay ? 1 : 0;
    return new Date(today.getFullYear(), today.getMonth() + startOffset + n - 1, 1);
}

export function estimateFromEntry(entry, today = new Date()) {
    if (!entry) return null;
    const balance = Number(entry.balance) || 0;
    const monthly = entry.monthly_share != null ? Number(entry.monthly_share) : null;
    const months = monthly ? monthsElapsed(entry.confirmed_date, today) : 0;

    // ยอดกู้: หักชำระทุกสิ้นเดือน → ยอดหนี้ลดลง (ไม่ติดลบ) — ไม่คำนวณดอกเบี้ย
    if (entry.account_type === 'loan') {
        const paid = monthly ? Math.min(balance, months * monthly) : 0;
        const remaining = Math.round((balance - paid) * 100) / 100;
        const monthsLeft = monthly ? Math.ceil(remaining / monthly) : null;
        return {
            isLoan: true,
            balance,
            monthly,
            months,
            paid,
            added: -paid,
            estimated: remaining,
            hasMonthly: !!monthly,
            monthsLeft,
            payoffDate: monthsLeft ? payoffMonth(monthsLeft, today) : null
        };
    }

    const added = monthly ? months * monthly : 0;
    return {
        balance,
        monthly,
        months,
        added,
        estimated: balance + added,
        hasMonthly: !!monthly
    };
}

export function formatMoney(n) {
    return (Number(n) || 0).toLocaleString('th-TH', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

const TH_MONTHS = ['ม.ค.', 'ก.พ.', 'มี.ค.', 'เม.ย.', 'พ.ค.', 'มิ.ย.', 'ก.ค.', 'ส.ค.', 'ก.ย.', 'ต.ค.', 'พ.ย.', 'ธ.ค.'];

export function formatThaiDate(v) {
    const d = toDateOnly(v);
    if (!d) return '-';
    return `${d.getDate()} ${TH_MONTHS[d.getMonth()]} ${d.getFullYear() + 543}`;
}

// 'ก.ย. 2570' จาก Date
export function formatThaiMonth(d) {
    if (!d) return '-';
    return `${TH_MONTHS[d.getMonth()]} ${d.getFullYear() + 543}`;
}

// ค่าสำหรับ <input type="date"> จากค่าที่ได้จาก API (DATE/ISO)
export function toInputDate(v) {
    const d = toDateOnly(v);
    if (!d) return '';
    const mm = String(d.getMonth() + 1).padStart(2, '0');
    const dd = String(d.getDate()).padStart(2, '0');
    return `${d.getFullYear()}-${mm}-${dd}`;
}
